// BP 56 §12 — the switcher (and the negotiation that would otherwise flip a
// non-English browser into a non-English UI) ships DARK behind the platform
// `Setting('i18n_ui_enabled')`. That Setting is now REAL and operator-flippable
// in Platform Admin → System settings; the backend exposes it on the auth
// payload as `user.platform_i18n_ui_enabled` (authController login + GET /me),
// so it rides into `authStore.user` and, verbatim, into the extension.
//
// `isI18nSwitcherEnabled(user)` reads that field. A dev/local override is still
// honored (env var or a localStorage key) so a developer can preview the
// feature without flipping the platform flag.
//
// Enable paths:
//   • Platform admin: System settings → `i18n_ui_enabled` ON  (the real switch)
//   • Dev, this machine: `VITE_I18N_UI_ENABLED=1 npm run dev`
//   • Dev, this browser: `localStorage.setItem('worksnip.i18n_ui_enabled_override','1')`
//
// IMPORTANT: this flag also gates the negotiation step in `index.ts` and the
// login-sync hook in `authStore.ts`, not just the switcher's visibility. With
// it off, the app is hard-pinned to `en` end-to-end regardless of browser
// language or a previously-persisted choice — so flipping it on is what makes
// a returning user's saved locale take effect.
export function isI18nSwitcherEnabled(
  user?: { platform_i18n_ui_enabled?: boolean | null } | null,
): boolean {
  // The real, operator-controlled platform Setting (via the auth payload).
  if (user?.platform_i18n_ui_enabled === true) return true;
  // Dev/local overrides — never reach production users.
  if (import.meta.env.VITE_I18N_UI_ENABLED === '1') return true;
  if (typeof localStorage === 'undefined') return false;
  try {
    return localStorage.getItem('worksnip.i18n_ui_enabled_override') === '1';
  } catch {
    return false; // private mode / storage disabled — stay dark, fail closed
  }
}
